import React from "react";
import SEO from "../../components/common/SEO";
import HeroSection from "../../components/home/HeroSection";
import TrustSection from "../../components/home/TrustSection";
import HowItWorksSection from "../../components/home/HowItWorksSection";
import CoreBenefitsSection from "../../components/home/CoreBenefitsSection";
import FeatureGridSection from "../../components/home/FeatureGridSection";
import SocialProofSection from "../../components/home/SocialProofSection";
import IntegrationsSection from "../../components/home/IntegrationsSection";
import SecuritySection from "../../components/home/SecuritySection";
import PricingTeaserSection from "../../components/home/PricingTeaserSection";
import FAQSection from "../../components/home/FAQSection";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();
  const handleStartTrial = () => {
    navigate("/product/email-validation");
  };

  const handleVerifyFree = () => {
     navigate("/product/bulk-validation");
  };

  const handleSeeAction = () => {
   navigate("/product/api");
  };

  return (
    <>
      <SEO
        title="VALIDMAIL - Real-Time Email Validation & Verification API | 98%+ Accuracy"
        description="Verify email addresses instantly with VALIDMAIL's powerful API. Real-time validation, bulk list cleaning, and deliverability scoring. Reduce bounces by 54% and improve inbox placement. GDPR, CCPA & India DPDP compliant. Start free."
        keywords="email validation API, email verification service, real-time email checker, bulk email validation, email deliverability, reduce bounce rate, email list cleaning, SMTP verification, disposable email detection, catch-all email detection, email validation for forms, CRM email validation, ESP integration, GDPR compliant email validation, India DPDP email compliance"
        canonicalUrl="https://validmail.io"
        type="website"
      />

      <div className="min-h-screen bg-white dark:bg-slate-950">
        <HeroSection
          onStartTrial={handleStartTrial}
          onVerifyFree={handleVerifyFree}
        />
        <TrustSection />
        <HowItWorksSection onSeeAction={handleSeeAction} />
        <CoreBenefitsSection />
        <FeatureGridSection />
        <SocialProofSection />
        <IntegrationsSection />
        <SecuritySection />
        <PricingTeaserSection />
        <FAQSection />
      </div>
    </>
  );
}
